/** @jsx jsx */
import { jsx } from "theme-ui"

import Button from "../Button"

import { triangle } from "../../../utils/styles"

const Circle = ({ color, ...props }) => (
  <span
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      border: "1px solid",
      borderColor: color,
      width: "22px",
      height: "22px",
      mr: 2,
    }}
    {...props}
  />
)

const CategorySwitcher = ({
  categories,
  active,
  onCategoryChange,
  forwardedSx,
}) => {
  return (
    <div
      sx={{
        display: "flex",
        bg: "background",
        boxShadow: "cardSmall",
        borderRadius: "2em",
        py: 3,
        px: 2,
        alignSelf: "center",
        "> *": {
          mx: 3,
        },
        "*": {
          transition: "all",
          transitionDuration: theme => theme.transitions.hover,
        },
        ...forwardedSx,
      }}
    >
      {categories.map((category, i) => {
        const isActive = active.find(activeCatId => activeCatId === category.id)
        const color = isActive ? (i ? "green" : "primary") : "gray"

        return (
          <Button
            key={category.id}
            variant="reset"
            onClick={() => onCategoryChange(category.id)}
            sx={{
              color,
            }}
          >
            {i ? (
              <Circle>
                <span
                  sx={{
                    ...triangle(color),
                  }}
                />
              </Circle>
            ) : (
              <Circle>
                <span
                  sx={{
                    bg: color,
                    borderRadius: "100%",
                    width: "6px",
                    height: "6px",
                  }}
                />
              </Circle>
            )}
            <span
              sx={{
                variant: "text.caps",
                color: color,
              }}
            >
              {category.name}
            </span>
          </Button>
        )
      })}
    </div>
  )
}

export default CategorySwitcher
